import styled from 'styled-components';
import PlaybookUsageDetails from './PlaybookUsageDetails';
import RecommendationBadge from './RecommendationBadge';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SmallerTitle = styled.div.withConfig({
  displayName: "BasePlaybookList__SmallerTitle"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    fontSize: theme.typography['body-125'].fontSize,
    fontWeight: theme.typography['body-125'].fontWeight,
    textAlign: 'left'
  };
});
export default function BasePlaybookList({
  handleOnClick,
  name,
  playbook,
  recommendationType
}) {
  return /*#__PURE__*/_jsxs(SelectableBox, {
    "data-selenium-test": "playbooks-list-item",
    type: "default",
    block: false,
    flush: true,
    selected: false,
    onClick: handleOnClick,
    marginInline: "0",
    marginBlock: "100",
    children: [/*#__PURE__*/_jsx(RecommendationBadge, {
      recommendationType: recommendationType
    }), /*#__PURE__*/_jsxs(TFlex, {
      justify: "start",
      direction: "column",
      paddingInline: "400",
      paddingBlock: "300",
      children: [/*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(Link, {
          children: /*#__PURE__*/_jsx(SmallerTitle, {
            children: name
          })
        })
      }), playbook.metadata.usageDetails && /*#__PURE__*/_jsx(PlaybookUsageDetails, {
        lastViewedAt: playbook.metadata.usageDetails.lastViewedAt,
        timesViewed: playbook.metadata.usageDetails.timesViewed
      })]
    })]
  });
}